/* eslint-disable array-callback-return */
/* eslint-disable react/display-name */
import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { Users, List, FileText, Medal, Info, Bell, User, ShieldChevron } from "phosphor-react";
import AppContext from "../../services/appContext";
import useAdminStore from "../../stores/useAdminStore";

const baseMenuItems = [
  {
    label: "About",
    path: "/about",
    icon: () => <Info color="rgba(55,81,157, 1)" size={32} />,
    type: "modal",
    accessLevel: "default",
    priority: 6,
  },
];

const menuItems = [
  {
    label: "My Team",
    path: "/my-team",
    icon: () => <Users color="rgba(55,81,157, 1)" size={32} />,
    type: "link",
    children: ["/my-team/", "/new-cascaded-objective"],
    accessLevel: "manager",
    priority: 0,
  },
  {
    label: "My 1-2-1s",
    path: "/my-1-2-1s",
    icon: () => <FileText color="rgba(55,81,157, 1)" size={32} />,
    type: "link",
    children: ["/view-1-2-1", "/new-1-2-1", "/edit-1-2-1"],
    ignore: ["/my-team/"],
    accessLevel: "default",
    priority: 1,
  },
  {
    label: "My Objectives",
    path: "/my-objectives/objectives",
    icon: () => <List color="rgba(55,81,157, 1)" size={32} />,
    type: "link",
    children: [
      "/my-objectives/PDP",
      "/view-objective",
      "/new-objective",
      "/edit-objective",
      "/view-development-goal",
      "/edit-development-goal",
      "/new-development-goal",
      "/close-objectives",
    ],
    ignore: ["/my-team/"],
    accessLevel: "default",
    priority: 2,
  },
  {
    label: "My Performance",
    path: "/my-performance",
    icon: () => <Medal color="rgba(55,81,157, 1)" size={32} />,
    type: "link",
    children: ["/new-review-prep", "/view-review-prep", "/edit-review-prep"],
    ignore: ["/my-team/"],
    accessLevel: "default",
    priority: 3,
  },
  {
    label: "Notifications",
    path: "/my-notifications",
    icon: () => <Bell color="rgba(55,81,157, 1)" size={32} />,
    type: "link",
    accessLevel: "default",
    priority: 4,
  },
  {
    label: "My Profile",
    path: "/",
    icon: () => <User color="rgba(55,81,157, 1)" size={32} />,
    type: "modal",
    accessLevel: "default",
    priority: 5,
  },
  ...baseMenuItems,
];

const adminMenuItems = [
  {
    label: "Admin",
    path: "/",
    icon: () => <ShieldChevron color="rgba(55,81,157, 1)" size={32} />,
    type: "link",
    accessLevel: "default",
    priority: 1,
  },
  ...baseMenuItems,
];

const HeaderMenuItems = (props) => {
  const { user, isLineManager, history, isDirtyForm, renderDirtyNavModal, click } = props;
  const isAdmin = useAdminStore((state) => state.isAdmin);
  const [isValidProfile, setIsValidProfile] = useState();
  const [latestUser, setLatestUser] = useState();
  const [renderMenu, setRenderMenu] = useState(menuItems);

  useEffect(() => {
    setIsValidProfile(JSON.parse(localStorage.getItem("isUserProfileValid")));
    setLatestUser(JSON.parse(localStorage.getItem("user")));
  }, [user]);

  useEffect(() => {
    setRenderMenu(isAdmin ? adminMenuItems : menuItems);
  }, [isAdmin]);

  const checkIsActive = (link, currentPath) => {
    let isActive = false;
    if (link.type === "link") {
      if (link.path === currentPath) {
        isActive = true;
      } else if (link.children) {
        link.children.map((childRoute) => {
          if (link.ignore) {
            link.ignore.map((ignore) => {
              if (currentPath.includes(childRoute) && !currentPath.includes(ignore)) {
                isActive = true;
              }
            });
          } else if (currentPath.includes(childRoute)) {
            isActive = true;
          }
        });
      }
    }
    return isActive;
  };

  const currentPath = history.location.pathname;

  const isMyObjective = (objectives) => {
    let isMyObj = false;
    if (!objectives) {
      return false;
    }
    objectives.map((objective) => {
      if (currentPath.includes(objective)) {
        isMyObj = true;
      }
      return isMyObj;
    });
    return isMyObj;
  };

  const onClickMenuItem = (path) => {
    if (
      (path === "/my-team" && !currentPath.includes("/my-team")) ||
      (path.includes("/my-objectives") && !isMyObjective(latestUser.objectives)) ||
      path === "/my-notifications" ||
      path === "/my-performance" ||
      path === "/my-1-2-1s"
    ) {
      props.setObjectivesFilters("dueDate", "");
      props.setObjectivesFilters("page", 1);
      props.setObjectivesFilters("pageSize", 5);
      props.setObjectivesFilters("status", "");
    }
    if (isDirtyForm) {
      renderDirtyNavModal(path, click || null);
    } else if (click) {
      click();
      props.history.push(path);
    } else {
      props.history.push(path);
    }
  };

  const renderMenuItem = (item) => {
    return (
      <React.Fragment key={item.label}>
        {(item.path === "/" || item.path === "/about" || item.path === "/my-notifications") &&
        !props.showIcons ? null : (
          <li
            style={{ lineHeight: "180%", letterSpacing: "0.0015em" }}
            className={checkIsActive(item, currentPath) ? "active" : ""}
            tabIndex={0}
            role="menuitem"
            onClick={() => {
              onClickMenuItem(item.path);
            }}
            onKeyDown={(e) => (e.key === "Enter" ? onClickMenuItem(item.path) : undefined)}
          >
            {props.showIcons && <div className="icon-wrapper">{item.icon()}</div>}
            {item.label}
          </li>
        )}
      </React.Fragment>
    );
  };

  const orderByPriority = (a, b) => {
    return a.priority <= b.priority ? -1 : 1;
  };

  const renderMenuItems = (itemsToRender) => {
    const menuItemsToRender = [];
    const validLM = !!(isLineManager && isValidProfile);

    const sortedItems = itemsToRender.sort(orderByPriority);

    sortedItems.forEach((menuItem) => {
      if (
        menuItem.path === "/" ||
        menuItem.path === "/about" ||
        menuItem.path === "/admin" ||
        (menuItem.path === "/my-performance" && isValidProfile) ||
        (menuItem.path === "/my-notifications" && isValidProfile) ||
        (menuItem.path.includes("/my-objectives") && isValidProfile) ||
        (menuItem.path === "/my-1-2-1s" && isValidProfile) ||
        (menuItem.path === "/my-team" && validLM)
      ) {
        menuItemsToRender.push(renderMenuItem(menuItem));
      }
    });
    return menuItemsToRender;
  };

  return (
    <AppContext.Consumer>
      {() => (
        <ul role="menu">
          {renderMenuItems(renderMenu)}
          {props.children}
        </ul>
      )}
    </AppContext.Consumer>
  );
};

export default withRouter(HeaderMenuItems);
